import { createCommentsPlugin } from '@adornis/web-editor/plugins/comments.js';
import { DocumentSession } from '@adornis/web-editor/client/DocumentSession.js';
import { decodeStructuredDocument } from '@adornis/web-editor/nodes/structured-document.js';
import type { LandingEditorProject } from '../../shared/editor/landingEditorTypes.js';

export { projectToDocument } from '../../shared/editor/landingStructureMapping.js';
import { projectToDocument } from '../../shared/editor/landingStructureMapping.js';
export const projectFromSession = (session: DocumentSession): LandingEditorProject =>
  decodeStructuredDocument(session.state.doc) as unknown as LandingEditorProject;
export const createLandingDocumentSession = (project: LandingEditorProject) => {
  const commentNodes = new Map<string, string[]>();
  const context = { locale: 'de' };
  return Object.assign(new DocumentSession(projectToDocument(project), [createCommentsPlugin({
    locale: () => context.locale,
    nodeId: node => commentNodes.get(String(node.attrs.id)),
  })]), { commentNodes, context });
};
